import type { ReportOrderStatus } from 'src/constants/report';
import { NO_REPORT_CONFIGURATION_VALUE } from 'src/constants/report';
import type { OriginalDataline } from 'src/types/dataline';
import type {
  PaginationStatus,
  WorkspaceReport,
  WorkspaceState,
} from 'src/types/workspace';

export const CUSTOM_REPORT_DEFAULTS: WorkspaceReport = {
  datalines: [] as OriginalDataline[],
  fileType: NO_REPORT_CONFIGURATION_VALUE,
  id: null,
  language: NO_REPORT_CONFIGURATION_VALUE,
  reportName: '',
  reportType: NO_REPORT_CONFIGURATION_VALUE as ReportOrderStatus,
};
Object.freeze(CUSTOM_REPORT_DEFAULTS.datalines);

const PAGINATION_DEFAULTS: PaginationStatus = {
  count: 0,
  hasNextPage: true,
  offset: 0,
};

export const WORKSPACE_DEFAULTS: WorkspaceState = {
  customReports: null,
  customReportsPaginationStatus: { ...PAGINATION_DEFAULTS },
  currentReport: { ...CUSTOM_REPORT_DEFAULTS, datalines: [] },
  datalineTemplates: null,
  datalineTemplatesPaginationStatus: { ...PAGINATION_DEFAULTS },
  errorMessage: null,
  loadingIndicatorIsShown: false,
};
Object.freeze(WORKSPACE_DEFAULTS);
